'use client';

import { FC, ReactNode, useEffect, useState } from 'react';

type Props = {
    children: ReactNode;
    loader?: ReactNode;
};

/** @name AsCSR
 * forcibly ignore SSR to omit hydration errors in Next.js */
export const AsCSR: FC<Props> = ({ children, loader }) => {
    const [isMounted, setIsMounted] = useState(false);

    useEffect(() => {
        setIsMounted(true);
    }, []);

    if (isMounted) {
        return <>{children}</>;
    }

    return loader || null;
};
